module.exports = __webpack_public_path__ + "361d665eeed6b1bc76dadbde8918bdca.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/logoCCDV.jpg
// module id = ./assets/images/footer/logoCCDV.jpg
// module chunks = 0